export default __webpack_public_path__ + "static/media/670.b268e066.jpg";